import customAxios from "./axiosConfig";

const TimerService = {
  start: function (data) {
    var api_url = window.Urls["timer_start_timer"]();
    var headers = {
      headers: {
          'Content-Type': 'multipart/form-data'
      }
    };
    return customAxios.post(api_url, data, headers);
  },
  resume: function (data) {
    var api_url = window.Urls["timer_restart_timer"]();
    var headers = {
      headers: {
          'Content-Type': 'multipart/form-data'
      }
    };
    return customAxios.post(api_url, data, headers);
  },
  pause: function (data) {
    var api_url = window.Urls["timer_pause_timer"]();
    var headers = {
      headers: {
          'Content-Type': 'multipart/form-data'
      }
    };
    return customAxios.post(api_url, data, headers);
  },
  destroyTimer: function (data) {
    var api_url = window.Urls["timer_destroy_timer"]();
    var headers = {
      headers: {
          'Content-Type': 'multipart/form-data'
      }
    };
    return customAxios.post(api_url, data, headers);
  },
  changeProject: function (data) {
    var api_url = window.Urls["timer_change_timer_project"]();
    var headers = {
      headers: {
          'Content-Type': 'multipart/form-data'
      }
    };
    return customAxios.post(api_url, data, headers);
  },
  getTimersV2: function (params) {
    var api_url = window.Urls["timer_get_timers"]();
    return customAxios.get(api_url, {params: params});
  },

  // V3
  // v3:timer_list
  // v3:timer_continue_timer
  // v3:timer_detail
  // v3:timer_pause_timer
  // v3:timer_start_timer
  // v3:timer_change_timer_project

  getTimers () {
    const api_url = window.Urls['v3:timer_list']()
    return customAxios.get(api_url)
  },
  startTimer (payload) {
    const api_url = window.Urls['v3:timer_start_timer']()
    return customAxios.post(api_url, payload)
  },
  pauseTimer (timer_id) {
    const api_url = window.Urls['v3:timer_pause_timer'](timer_id)
    return customAxios.post(api_url)
  },
  continueTimer (timer_id) {
    const api_url = window.Urls['v3:timer_continue_timer'](timer_id)
    return customAxios.post(api_url)
  },
  changeTimerProject (timer_id, payload) {
    const api_url = window.Urls['v3:timer_change_timer_project'](timer_id)
    return customAxios.post(api_url, payload)
  },
  deleteTimer (timer_id) {
    const api_url = window.Urls['v3:timer_detail'](timer_id)
    return customAxios.delete(api_url)
  }
};

export default TimerService;